<div nxModalContent>
  <nx-card class="w-100">
    <nx-card-header>
      <h3 nxHeadline="subsection-small" class="nx-margin-bottom-s">
        {{'general.selectContractEditType' | caption}}
      </h3>
    </nx-card-header>
    <div nxLayout="grid">
      <div nxRow="">
        <div nxCol="12">
          <nx-formfield label="{{'contract.editTypes' | caption}}">
            <nx-dropdown
              #ngModelDropdown
              name="test"
              [(ngModel)]="selectedEditType"
              >
              @for (editType of editTypes; track editType) {
                <nx-dropdown-item
                [value]="editType">{{'contract.selectEditType' + editType | caption}}</nx-dropdown-item>
              }
            </nx-dropdown>
          </nx-formfield>
        </div>
        @if (availableDateModifyingType && availableDateModifyingType != 'date') {
          <div nxCol="12">
            <nx-message context="info" class="nx-margin-bottom-s">
              <span class="nx-font-weight-bold">{{'general.info' | caption}}</span><br/>
              {{'contract.' + availableDateModifyingType + 'Info' | caption}}
            </nx-message>
          </div>
        }
        <div nxCol="12">
          <nx-message context="info">
            <span class="nx-font-weight-bold">{{'contract.selectEditTypeHead' | caption}}</span><br/>
            {{'contract.selectEditType' | caption}}
          </nx-message>
        </div>
      </div>
    </div>
  </nx-card>
</div>
<div nxModalActions>
  <button
    nxModalClose="cancel"
    class="nx-margin-bottom-0 nx-margin-right-xs"
    nxButton="small secondary"
    type="button"
    >
    {{'general.cancel' | caption}}
  </button>
  <button
    [nxModalClose]="selectedEditType"
    class="nx-margin-bottom-0"
    nxButton="small"
    type="button"
    >
    {{'general.select' | caption}}
  </button>
</div>
